
export const TERMS_OF_USE = 'https://www.7-eleven.com/legal/terms';
export const PRIVACY_POLICY = 'https://www.7-eleven.com/consumer-privacy-notice';
export const BACK_TO_LOGIN = 'Back to Login';
export const RESET_PASSWORD = 'Reset Password';
export const RESET_PASSWORD_SUB_TEXT = 'An email has been sent to the email on file with a OTP. Please enter the code below.';
export const CONNECT = 'Connect';
export const ACTIVATE = 'Activate';
export const DEACTIVATE = 'Deactivate';
export const CONTINUE = 'Continue';
export const LOG_IN_TITLE = 'Log In or Sign Up';
export const LOG_IN = 'Log In';
export const SEND_EMAIL = 'Send Email';
export const FORGOT_PASSWORD = 'Forgot Password?';
export const CANCEL = 'Cancel';
export const UPDATE_PASSWORD = 'Update Password';
export const CONFIRM_PASSWORD_RESET = 'Confirm Password Reset';
export const CHANGE_PASSWORD = 'Change Password';
export const CREATE_PASSWORD = 'Create a New Password';
export const CREATE_ACCOUNT = 'Create Account';
export const CREATE_ADMIN_TITLE = 'Create an Admin Account';
export const SEVEN_ELEVEN_TEXT = '7-Eleven';
export const VIEW_DASHBOARD_TEXT = 'View Dashboard';
export const STORE_TEXT = 'Store';
export const DASHBOARD_TEXT = 'Business';
export const YOUR_STORES_TEXT = 'Your Stores';
export const NO_STORES_TEXT = ' No Stores Available';
export const BUISNESS_GROUP_TEXT = 'Business Group';
export const ORDER_TEXT = 'Orders';
export const PRIVACY_POLICY_CONTENT = {
    AGREE: `By clicking on Log in, You acknowledge 7-Eleven's`,
    PRIVACY_POLICY_LABEL: 'Privacy Notice',
    AND: 'and agree to the ',
    TERMS_OF_USE_LABEL: '7NOW Merchant Portal Terms of Use.'
}

export const USERNAME_EMAIL_REQUIRED = 'Username / Email is Required';
export const PASSWORD_REQUIRED = 'Password is Required';
export const MINI_CHAR = 'must be 6 character';
export const PASS_MINI_CHAR = 'Password must be greater than 6 character';
export const NEW_USER_ADVICE = '. Please sign up with new user name';
export const MERCHANT_PORTAL_TEXT = 'Merchant Portal';
export const BACK_TEXT = 'Back';
export const REQ_ACCESS_TEXT = 'Request Access';
export const GETTING_STARTED = 'Get Started';
export const DETAILS_TEXT = 'Details';
export const SEARCH_A_STORE_ID = 'Search a Store ID';
